module.exports = __webpack_public_path__ + "static/media/linkIcon.c3c31f4d.svg";